import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, CreditCard, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ReadyForABetterHr() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="21567" id="scale-your-voice" className="dark bg-background text-foreground relative overflow-hidden py-32 flex items-center justify-center min-h-[600px]">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a2e] to-[#07070a] z-0" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_70%)] opacity-20 z-0 pointer-events-none mix-blend-screen" />

      {}
      <div className="absolute inset-0 z-0 opacity-20 pointer-events-none">
        <svg className="w-full h-full" viewBox="0 0 1440 800" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
          {}
          <path d="M-100 400 H 300 L 400 300 L 550 300" stroke="var(--color-primary)" strokeWidth="2" className="animate-[pulse_4s_ease-in-out_infinite]" />
          <path d="M-100 600 H 200 L 300 500 L 500 500" stroke="var(--color-primary)" strokeWidth="1" strokeOpacity="0.4" />
          <circle cx="550" cy="300" r="3" fill="var(--color-primary)" className="animate-bounce" />
          
          {}
          <path d="M1540 400 H 1140 L 1040 500 L 890 500" stroke="var(--color-primary)" strokeWidth="2" className="animate-[pulse_5s_ease-in-out_infinite_1s]" />
          <path d="M1540 200 H 1240 L 1140 300 L 940 300" stroke="var(--color-primary)" strokeWidth="1" strokeOpacity="0.4" />
          <circle cx="890" cy="500" r="3" fill="var(--color-primary)" className="animate-bounce" />

          {}
          <path d="M720 0 V 200" stroke="var(--color-primary)" strokeWidth="1" strokeOpacity="0.2" />
          <path d="M720 800 V 600" stroke="var(--color-primary)" strokeWidth="1" strokeOpacity="0.2" />
        </svg>
      </div>

      {}
      <div ref={ref} className={cn("relative z-10 container mx-auto px-4 text-center transition-all duration-1000 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="text-5xl md:text-7xl font-bold tracking-tighter text-white mb-12 drop-shadow-2xl max-w-4xl mx-auto">
          Ready to Scale Your Voice with AI?
        </h2>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12">
          {}
          <Button asChild variant="ghost" className="text-lg text-white/70 hover:text-white hover:bg-white/5 transition-colors order-2 md:order-1">
            <Link to="/TechnologyPage" className="flex items-center gap-2">
              <CreditCard className="w-5 h-5" />
              Our Technology
            </Link>
          </Button>

          {}
          <Button asChild size="lg" className="bg-white text-[#0a0a1f] hover:bg-white/90 text-xl px-12 py-8 rounded-lg shadow-[0_0_50px_-10px_rgba(255,255,255,0.3)] hover:shadow-[0_0_70px_-10px_rgba(255,255,255,0.5)] transition-all duration-500 scale-100 hover:scale-105 order-1 md:order-2">
            <Link to="/ContactUsPage">
              Request Demo
              <ArrowRight className="ml-2 w-6 h-6" />
            </Link>
          </Button>

          {}
          <Button asChild variant="ghost" className="text-lg text-white/70 hover:text-white hover:bg-white/5 transition-colors order-3">
            <Link to="/ContactUsPage" className="flex items-center gap-2">
              <Phone className="w-5 h-5" />
              Contact Us
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}